// src/index.js - Optimized for production
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Only use StrictMode in development
const AppWrapper = process.env.NODE_ENV === 'development' ? (
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>
) : (
    <HelmetProvider>
        <App />
    </HelmetProvider>
);

root.render(AppWrapper);

reportWebVitals();